import { ApiError } from "@vana/core";
//#region src/domain/errors/errors.ts
var GetPostsError = class extends ApiError {};
//#endregion
export { GetPostsError };

//# sourceMappingURL=errors.js.map